import PropTypes from 'prop-types';

const shortlistShape = {
  '@id':      PropTypes.string.isRequired,
  '@type':    PropTypes.string.isRequired,
  id:         PropTypes.string.isRequired,
  name:       PropTypes.string.isRequired,
  user:       PropTypes.string,
};


const shortlistPropType = PropTypes.shape(shortlistShape);

export { shortlistShape, shortlistPropType };


// WEBPACK FOOTER //
// ./src/domain/shortlist.js